import React from "react";
// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function Certificates() {

  // useEffect(()=>{
  //     document.title = 'Elixir | Our Certificates';
  //   }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Certificates</span></h1>
                <h4>Powering Your Prints, Elevating Your Business</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="aboutPages-box2">
                  <img src={require('../assets/img/certificates-page-banner-1.jpg')} className="img-fluid" alt="elixir" />
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div className="innerPages-box3">      
                <div className="logoPart">
                  <h5><span>"</span>A Complete Communication Solutions<span>"</span></h5>
                  <hr />
                  <p><span>Mail:</span> <a href="mailto:anand@elixirworldwide.com">anand@elixirworldwide.com</a></p>
                  <p><span>Mobile:</span> <a href="tel:+966552301809">+966 55 230 1809</a></p>         
                </div>
              </div> 
            </Col>
          </Row>
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">
                <div className="contactMap-text">
                  <h3>Global Standards, Premium Certificates</h3>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="aboutPages-box5">
                <h4>Your Trusted Partner for High-Standard Certificates.</h4>
                <p>1. Elixir Advertising delivers top-quality certificates designed to uphold professional, academic, and organizational excellence.</p>
                <p>2. As a global leader in certification solutions, we ensure authenticity, precision, and trust in every certificate we create.</p>
                <p>3. We specialize in designing premium, credible certificates that celebrate achievement and recognition worldwide.</p>
                <p className="mb-3">4. With unmatched craftsmanship and high standards, Elixir Advertising is the reliable choice for professionally crafted certificates.</p>
                <Row>
                  <Col lg={6}>
                    <img src={require('../assets/img/appreciation-letter-img-1.jpg')} className="img-fluid certificateImg" alt="elixir" /> 
                  </Col>
                  <Col lg={6}>
                    <img src={require('../assets/img/appreciation-letter-img-2.jpg')} className="img-fluid certificateImg" alt="elixir" /> 
                  </Col>
                </Row> 
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Certificates;
